import '../App.css';
import Navbar from '../components/Navbar';
import CartItem from '../components/CartItem';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default function Cart({
    cart, setCart, totalCost, setTotalCost, totalQty, setTotalQty}) {

    
    const shipping = 0.15;
    const tax = 0.07;

    const round = num => {
        return (num * 1).toFixed(2);
    }
    const getShipping = () => {
        return (totalCost <= 30) ? (totalCost * shipping) : 0;
    }

    const getTotal = () => {
         return totalCost + (totalCost * tax) + getShipping();
    }

    return (<>
        <Navbar />
        <main className='cart-main'>
            <section className='cart-list'>{(cart.length) ?
                cart.map(item =>
                    <CartItem
                        key={item.id}
                        book={item}
                        cart={cart}
                        setCart={setCart}
                        totalCost={totalCost}
                        setTotalCost={setTotalCost}
                        totalQty={totalQty}
                        setTotalQty={setTotalQty}
                    />
                ) : <h1 className='empty-cart'>Your Cart is Empty</h1>}
            </section>
            <section className='cart-calculations'>
                <div>
                    <p>
                        <span>Items:</span>
                        <span>{totalQty}</span>
                    </p>
                    <p>
                        <span>Gross total:</span>
                        <span>${round(totalCost)}</span>
                    </p>
                    <p>
                        <span>Shipping:</span>
                        <span>{(getShipping()) ? '$'+round(getShipping()) : 'Free'}</span>
                    </p>
                    <p>
                        <span>Tax:</span>
                        <span>${round(tax * totalCost)}</span>
                    </p>
                    <p>
                        <span>Final:</span>
                        <span>${round(getTotal())}</span>
                    </p>
                </div>
                {(cart.length) ? (
                    <Link className='checkout-btn' to={'/checkout'}>Check Out</Link>
                ) : (
                    <span className='checkout-btn-disabled'>Check Out</span>
                )}
            </section>
        </main>
        <Footer />
    </>)

}
